import { IState } from 'legacy/lut/store'
import { createSelector } from 'reselect'

const widgetEvent = (state: IState) => state.widgetEvent

export const selectWidgetEvent = (widgetName: string) =>
  createSelector(widgetEvent, (widgetEvent) => widgetEvent[widgetName])
